import { CheckCircle2, LockKeyhole } from "lucide-react";
import { FormEvent, useState } from "react";
import { api, ApiError } from "../lib/api";
import { Link, useSearchParams } from "../lib/router";

export function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? "";

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError("");

    if (!token) {
      setError("Link inválido ou expirado.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("As palavras-passe não coincidem.");
      return;
    }

    setBusy(true);
    try {
      await api("/auth/reset-password", {
        method: "POST",
        body: JSON.stringify({ token, newPassword }),
      });
      setDone(true);
    } catch (cause) {
      if (cause instanceof ApiError && cause.message === "invalid_or_expired_token") {
        setError("Este link é inválido ou já expirou. Pede um novo.");
      } else {
        setError("Não foi possível redefinir a palavra-passe.");
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-visual">
        <div className="login-visual__grid" />
        <div className="login-brand">
          <img src="/brand/pagaqui.svg" alt="PAGAQUI" />
          <span>Pagaqui Wallet - Backoffice</span>
        </div>
        <div className="login-visual__copy">
          <span className="eyebrow eyebrow--light">
            Pagaqui Wallet - Backoffice
          </span>
          <h1>Define uma nova palavra-passe.</h1>
        </div>
      </section>

      <section className="login-panel">
        {done ? (
          <div className="login-form">
            <div className="login-form__icon">
              <CheckCircle2 size={24} />
            </div>
            <span className="eyebrow">Concluído</span>
            <h2>Palavra-passe redefinida</h2>
            <p>Já podes entrar com a tua nova palavra-passe.</p>
            <Link className="button button--primary button--full" to="/login">
              Ir para o login
            </Link>
          </div>
        ) : (
          <form className="login-form" onSubmit={submit}>
            <div className="login-form__icon">
              <LockKeyhole size={24} />
            </div>
            <span className="eyebrow">Nova palavra-passe</span>
            <h2>Redefinir palavra-passe</h2>

            <label>
              Nova palavra-passe
              <input
                type="password"
                autoComplete="new-password"
                value={newPassword}
                onChange={(event) => setNewPassword(event.target.value)}
                required
                minLength={12}
                autoFocus
              />
            </label>

            <label>
              Confirmar palavra-passe
              <input
                type="password"
                autoComplete="new-password"
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
                required
                minLength={12}
              />
            </label>

            {error && (
              <div className="form-error" role="alert">
                {error}
              </div>
            )}

            <button
              className="button button--primary button--full"
              disabled={busy}
            >
              {busy ? (
                <span className="spinner spinner--button" />
              ) : (
                "Redefinir palavra-passe"
              )}
            </button>
            <Link to="/login">Voltar ao login</Link>
          </form>
        )}
      </section>
    </main>
  );
}
